<template>
  <div>
    <div v-if="computedFilterInputLength > 0">
      <span class="text-bold">Active Filters</span>:
      <span v-for="fi in computedFilterInput" :key="fi.id" class="fi">
        <template
          v-if="(fi.type === 'range' || fi.type === 'rating_range') && !fi.hide"
        >
          {{ fi.label }}:&nbsp;
          <q-chip
            v-for="(item, index) in fi.filter"
            :removable="fi.removable[index] !== false"
            :key="index"
            @remove="removeToolbarFilterItem(fi.id, index)"
            size="md"
            square
          >
            <span v-if="['OLGDP012', 'OLGDP098'].includes(fi.id)"
              >${{ String(item) }}</span
            >
            <span v-else>{{ String(item) }}</span>
          </q-chip>
        </template>
        <template v-else-if="fi.type !== 'range' || fi.type !== 'rating_range'">
          {{ fi.label }}:&nbsp;
          <q-chip
            v-for="(item, index) in fi.filter"
            removable
            :key="index"
            @remove="removeToolbarFilterItem(fi.id, index)"
            size="md"
            square
            >{{ String(item) }}
          </q-chip>
        </template>
      </span>
    </div>
    <div v-if="weatherFilterInput">
      <q-chip removable @remove="removeWeatherFilter" size="md" square
        >Weather</q-chip
      >
    </div>
    <div
      v-if="
        computedFilterInputLength > 0 || weatherFilterInput || recentlyAdded
      "
      class="q-py-md"
    >
      <q-btn
        label="Clear All Filters"
        color="primary"
        size="sm"
        push
        @click="clickReset"
      ></q-btn>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "FilterBar",
  computed: {
    ...mapState(["filterInput", "weatherFilterInput", "recentlyAdded"]),
    ...mapGetters(["filteredCourses", "filterDatapoints"]),
    computedFilterInput() {
      return this.filterInput.map(fi => {
        if (fi.type === "range" || fi.type === "rating_range") {
          const meta = this.filterDatapoints.find(m => m.id === fi.id);
          if (!fi.removable) {
            fi.removable = {};
          }

          ["min", "max"].forEach(m => {
            fi.removable[m] = fi.filter[m] !== meta[m];
          });

          fi.hide = ["min", "max"].every(m => fi.removable[m] === false);
        }

        return fi;
      });
    },
    computedFilterInputLength() {
      return this.computedFilterInput.filter(fi => {
        if (Object.prototype.hasOwnProperty.call(fi, "hide")) {
          return fi.hide !== true;
        } else {
          return fi;
        }
      }).length;
    },
  },
  methods: {
    clickReset() {
      this.$emit("reset");
    },
    removeToolbarFilterItem(id, index) {
      const meta = this.filterDatapoints.find(dp => dp.id === id);
      const newFilterInput = this.filterInput.slice(0);

      if (meta.filterType === "range" || meta.filterType === "rating_range") {
        // in the case of a range the value of index is "min" or "max"
        // we reset to minimum/maximum value from metadata
        newFilterInput.find(f => f.id === id).filter[index] = meta[index];

        // if the min and max match the minimum and maximum from meta
        // remove the filter entirely
        const item = newFilterInput.find(f => f.id === id);
        const existingIndex = newFilterInput.findIndex(f => f.id === id);
        const { min, max } = meta;
        let shouldRemoveRange =
          item.filter.min === min && item.filter.max === max;

        if (meta.filterType === "rating_range") {
          // we need to account for a min of 0 in the range meaning not rated
          shouldRemoveRange = item.filter.min === 1 && item.filter.max === max;
        }

        if (shouldRemoveRange) {
          newFilterInput.splice(existingIndex, 1);
        }
      } else {
        // remove the chip's corresponding value from the item's filter object
        newFilterInput.find(f => f.id === id).filter.splice(index, 1);
      }

      this.$store.commit("setFilterInput", newFilterInput);
    },
    removeWeatherFilter() {
      this.$store.commit("setWeatherFilterInput", "reset");
      this.$store.commit("setWeatherFilterZips", null);
    },
    removeRecentlyAdded() {
      this.$store.commit("setRecentlyAdded", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.fi {
  padding-right: 10px;
}
</style>
